import {BBS_CATEGORY} from '../defines/protocol';
import {Txt2Date} from '../defines/common.func';


export class Article {
  no: number;
  title: string;
  thumbnail: string;
  content: string;
  brief: string;
  category: BBS_CATEGORY;
  lastModified?: Date;
  registered?: Date;


  constructor(obj?: any) {
    this.no                 = (obj && obj.no)                 ?? null;
    this.title              = (obj && obj.title)              ?? null;
    this.thumbnail          = (obj && obj.thumbnail)          ?? null;
    this.content            = (obj && obj.content)            ?? null;
    this.brief              = (obj && obj.brief)              ?? null;
    this.category           = (obj && obj.category as BBS_CATEGORY) ?? null;
    this.lastModified       = (obj && obj.last_modified)      ?? Txt2Date(obj.last_modified);
    this.registered         = (obj && obj.registered)         ?? Txt2Date(obj.registered);
  }
}


